var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacBonneReponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sac",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.01 459.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-16,.cls-2{stroke:#fff;}.cls-1,.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-2,.cls-9{stroke-miterlimit:10;}.cls-1{stroke-width:6px;}.cls-2{stroke-width:5px;}.cls-3{fill:#2a2a28;}.cls-4{fill:#f8b71f;}.cls-5{fill:#4c4e4d;}.cls-6{fill:#202120;}.cls-7{fill:#ffd02e;}.cls-8{fill:#1c1c1c;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-9{fill:none;stroke-width:2px;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-9{stroke:#b3b3ba;}.cls-10{stroke-dasharray:5.95 1.98;}.cls-11{opacity:0.67;}.cls-12{stroke-dasharray:6.92 2.31;}.cls-13{stroke-dasharray:4.25 1.42;}.cls-14{stroke-dasharray:5.29 1.76;}.cls-15{stroke-dasharray:5.79 1.93;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sac bonne r\xE9ponse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2_mauvaise",
    "data-name": "2 mauvaise"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 142.01,
    cy: 74,
    r: 71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.07,834l-37.16,47",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1052.77,955.26c7.21-61.86,36-125.62,25.1-135.26C1054.22,799,974,792,974,792s-80.22,7-103.87,28c-10.85,9.64,14.15,67.65,21.37,129.5l-1,134h164Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.93,834l37.16,47",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M892.5,888.5,863,1097c-6.54,18.5-26.83,16-28.54-1.5,0,0,12-254.5,35.63-275.5",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1054.5,893.5l27.93,203.5c6.07,23.5,27.36,16,29.07-1.5,0,0-9.52-254.5-33.16-275.5",
    transform: "translate(-831.99 -655)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sac-2",
    "data-name": "sac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M973.57,1035.6s-68.81.79-71.43,0-2.61-1.3-2.61-1.3-8.11-.79-9.42-1.31-5.5-1.83-7.07-5.5-3.4-11-4.18-22c-5.23-7.59-9.42-28.78-9.94-33.23s-1-17.79.26-22.76a73.73,73.73,0,0,1,2.35-7.59s-.78-3.66-.26-4.71,4.71-1.83,5-1.83,3.93-1.31,3.93-2.36,6.54-52.06,9.41-60.7,13.74-35.84,23-40.29c-2.09-7.06-6-25.9-3.93-32.18.27-1,1.57-1,3.67-1s21.71-3.93,21.71-3.93a19.35,19.35,0,0,0,4.19-1,4.18,4.18,0,0,1,5.75,1l11,22,18.58-.26Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M973.57,914.55l-61.75-.08s-.85-13,5.24-17.53c3.14-2.36,7.85-2.88,13.08-2.88h43.43Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "76.95 365.95 79.83 259.47 141.57 259.47 141.57 365.95 76.95 365.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M898.22,1021s6.54-110.41,8.37-116.69,8.37-12.82,12-13.34,25.37-3.14,34-3.66,21-1.5,21-1.5l-.1,3.26s-50.19,2.69-54.38,4.78-8.63,8.11-8.9,10.46S902.93,1021,902.93,1021Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M884.88,1027.75s3.92-26.42,5.23-43.69,8.37-92.35,7.06-102.3h-2.09s-13.61,110.93-13.61,123.49C881.47,1013.89,884.88,1027.75,884.88,1027.75Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M925.17,851.68h19.62s-1.83-29.31,0-36.37,4.45-23.55,4.19-25.9a4.65,4.65,0,0,1-1.05-.79s6.54-6.28,25.64-5.49v-7.07s-12.82-.78-24.07,3.14c-1.83.79-4.71.53-5.76,1.57s-1.83,3.67-5,8.11c-3.92,6.54-8.37,9.42-10.73,14.92S924.91,841,925.17,851.68Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 121.95,
    y: 265.75,
    width: 19.62,
    height: 13.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 79.31,
    y: 286.42,
    width: 62.27,
    height: 6.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M919.41,941.68s-.26-.79-1.57-.79-2.09,1.83-2.09,1.83h-1.83a2.41,2.41,0,0,1-.79,1.57c-.78.79,0,13.09,0,13.09S912.87,961,916,961a3.39,3.39,0,0,0,3.4-3.14s-1-8.11-1-9.94c.53-.26,1-1.57,1-1.57h3.4v-4.71ZM916,960a2.09,2.09,0,1,1,2.09-2.09A2.09,2.09,0,0,1,916,960Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M972,884.38l-2.09-.78s-4.71.26-5,.78-1.84,1.57-1.31,2.35l.52.53s-1,4.71-.78,5.75.78,2.36,2.61,2.36,3.4-.79,3.66-1.83-.52-5.24-.52-5.24h2.36a2,2,0,0,0,1-.78C972.78,887,972,884.38,972,884.38Zm-5.63,9.94c-1.22,0-2.22-.58-2.22-1.31s1-1.3,2.22-1.3,2.23.58,2.23,1.3S967.6,894.32,966.37,894.32Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M968.6,814.26l-3.93-.52-3.14,3.66h.78s-2.87,4.19-3.13,4.71a2.22,2.22,0,0,0,0,1.83c.26.26,5.76-1,6.28-1.31s.74-5.23.74-5.23H972v-1Zm-3.14,2.1,1.83-1.05,2.88.78.52.27Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 70.15,
    y1: 197.46,
    x2: 73.15,
    y2: 197.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 75.13,
    y1: 197.46,
    x2: 137.58,
    y2: 197.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 138.57,
    y1: 197.46,
    x2: 141.57,
    y2: 197.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.96,
    y1: 195.37,
    x2: 96.96,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 99.26,
    y1: 195.37,
    x2: 107.33,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 108.49,
    y1: 195.37,
    x2: 111.49,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.96,
    y1: 182.29,
    x2: 96.96,
    y2: 182.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 99.26,
    y1: 182.29,
    x2: 107.33,
    y2: 182.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 108.49,
    y1: 182.29,
    x2: 111.49,
    y2: 182.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.96,
    y1: 182.29,
    x2: 93.96,
    y2: 185.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 93.96,
    y1: 186.7,
    x2: 93.96,
    y2: 191.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.96,
    y1: 192.37,
    x2: 93.96,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 111.49,
    y1: 182.29,
    x2: 111.49,
    y2: 185.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 111.49,
    y1: 186.7,
    x2: 111.49,
    y2: 191.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 111.49,
    y1: 192.37,
    x2: 111.49,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.96,
    y1: 182.29,
    x2: 96.36,
    y2: 184.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 97.78,
    y1: 185.14,
    x2: 108.38,
    y2: 193.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 109.08,
    y1: 193.57,
    x2: 111.49,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 111.49,
    y1: 182.29,
    x2: 109.08,
    y2: 184.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 107.67,
    y1: 185.14,
    x2: 97.07,
    y2: 193.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 96.36,
    y1: 193.57,
    x2: 93.96,
    y2: 195.37
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 70.15,
    y1: 200.6,
    x2: 73.15,
    y2: 200.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 75.13,
    y1: 200.6,
    x2: 137.58,
    y2: 200.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 138.57,
    y1: 200.6,
    x2: 141.57,
    y2: 200.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M888.8,1020.69c.23.39,1.19.74,2.76,1",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M893.45,1022.06c12.69,1.81,48.51,2.12,76.15,1.59",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M970.57,1023.63l3-.06",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M973.57,1035.6s68.81.79,71.42,0,2.62-1.3,2.62-1.3,8.11-.79,9.42-1.31,5.49-1.83,7.06-5.5,3.41-11,4.19-22c5.23-7.59,9.42-28.78,9.94-33.23s1-17.79-.26-22.76a73.73,73.73,0,0,0-2.35-7.59s.78-3.66.26-4.71-4.71-1.83-5-1.83S1067,934.09,1067,933s-6.54-52.06-9.42-60.7-13.73-35.84-23-40.29c2.09-7.06,6-25.9,3.92-32.18-.26-1-1.57-1-3.66-1s-21.71-3.93-21.71-3.93a19.21,19.21,0,0,1-4.19-1,4.19,4.19,0,0,0-5.76,1l-11,22-18.57-.26Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M973.57,914.55l61.74-.08s.86-13-5.23-17.53c-3.14-2.36-7.85-2.88-13.08-2.88H973.57Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "206.2 365.95 203.32 259.47 141.57 259.47 141.57 365.95 206.2 365.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1048.92,1021s-6.54-110.41-8.37-116.69-8.38-12.82-12-13.34-25.38-3.14-34-3.66-21-1.5-21-1.5l.1,3.26s50.19,2.69,54.38,4.78,8.63,8.11,8.89,10.46,7.33,116.69,7.33,116.69Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1062.26,1027.75s-3.92-26.42-5.23-43.69-8.37-92.35-7.06-102.3h2.09s13.6,110.93,13.6,123.49C1065.66,1013.89,1062.26,1027.75,1062.26,1027.75Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1022,851.68h-19.62s1.83-29.31,0-36.37-4.45-23.55-4.19-25.9a4.65,4.65,0,0,0,1.05-.79s-6.54-6.28-25.64-5.49v-7.07s12.82-.78,24.07,3.14c1.83.79,4.71.53,5.76,1.57s1.83,3.67,5,8.11c3.92,6.54,8.37,9.42,10.72,14.92S1022.23,841,1022,851.68Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 973.57,
    y: 920.75,
    width: 19.62,
    height: 13.08,
    transform: "translate(1134.77 1199.58) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 973.57,
    y: 941.42,
    width: 62.27,
    height: 6.02,
    transform: "translate(1177.41 1233.85) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1024.33,941.68v4.71h3.4s.52,1.31,1,1.57c0,1.83-1,9.94-1,9.94a3.39,3.39,0,0,0,3.4,3.14c3.14,0,2.88-3.66,2.88-3.66s.78-12.3,0-13.09a2.41,2.41,0,0,1-.79-1.57h-1.83s-.78-1.83-2.09-1.83-1.57.79-1.57.79ZM1029,957.9a2.09,2.09,0,1,1,2.09,2.09A2.08,2.08,0,0,1,1029,957.9Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M974.62,887.52a2,2,0,0,0,1,.78H978s-.79,4.19-.53,5.24,1.83,1.83,3.67,1.83,2.35-1.31,2.61-2.36-.78-5.75-.78-5.75l.52-.53c.52-.78-1-1.83-1.31-2.35s-5-.78-5-.78l-2.09.78S974.35,887,974.62,887.52Zm3.92,5.49c0-.72,1-1.3,2.22-1.3s2.23.58,2.23,1.3-1,1.31-2.23,1.31S978.54,893.74,978.54,893Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M975.14,816.36v1h5.8s.22,5,.74,5.23,6,1.57,6.28,1.31a2.22,2.22,0,0,0,0-1.83c-.26-.52-3.13-4.71-3.13-4.71h.77l-3.14-3.66-3.92.52Zm1.31,0,.52-.27,2.88-.78,1.83,1.05Z",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 213,
    y1: 197.46,
    x2: 210,
    y2: 197.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 208.02,
    y1: 197.46,
    x2: 145.57,
    y2: 197.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 144.57,
    y1: 197.46,
    x2: 141.57,
    y2: 197.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 189.19,
    y1: 195.37,
    x2: 186.19,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 183.89,
    y1: 195.37,
    x2: 175.82,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 174.66,
    y1: 195.37,
    x2: 171.66,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 189.19,
    y1: 182.29,
    x2: 186.19,
    y2: 182.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 183.89,
    y1: 182.29,
    x2: 175.82,
    y2: 182.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 174.66,
    y1: 182.29,
    x2: 171.66,
    y2: 182.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 189.19,
    y1: 182.29,
    x2: 189.19,
    y2: 185.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 189.19,
    y1: 186.7,
    x2: 189.19,
    y2: 191.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 189.19,
    y1: 192.37,
    x2: 189.19,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 171.66,
    y1: 182.29,
    x2: 171.66,
    y2: 185.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 171.66,
    y1: 186.7,
    x2: 171.66,
    y2: 191.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 171.66,
    y1: 192.37,
    x2: 171.66,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 189.19,
    y1: 182.29,
    x2: 186.79,
    y2: 184.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 185.37,
    y1: 185.14,
    x2: 174.77,
    y2: 193.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 174.07,
    y1: 193.57,
    x2: 171.66,
    y2: 195.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 171.66,
    y1: 182.29,
    x2: 174.07,
    y2: 184.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 175.48,
    y1: 185.14,
    x2: 186.08,
    y2: 193.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 186.79,
    y1: 193.57,
    x2: 189.19,
    y2: 195.37
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 213,
    y1: 200.6,
    x2: 210,
    y2: 200.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 208.02,
    y1: 200.6,
    x2: 145.57,
    y2: 200.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 144.57,
    y1: 200.6,
    x2: 141.57,
    y2: 200.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1058.34,1020.69c-.23.39-1.19.74-2.76,1",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1053.68,1022.06c-12.69,1.81-48.5,2.12-76.14,1.59",
    transform: "translate(-831.99 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M976.57,1023.63l-3-.06",
    transform: "translate(-831.99 -655)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1078,949.53a73.73,73.73,0,0,0-2.35-7.59s.78-3.66.26-4.71-4.71-1.83-5-1.83S1067,934.09,1067,933s-6.54-52.06-9.42-60.7-13.73-35.84-23-40.29c2.09-7.06,6-25.9,3.92-32.18-.26-1-1.57-1-3.66-1s-21.71-3.93-21.71-3.93l-.37-.06a44.08,44.08,0,0,1-4.34-6c-3.14-4.44-3.93-7.06-5-8.11s-3.93-.78-5.76-1.57c-11.25-3.92-24.07-3.14-24.07-3.14s-12.82-.78-24.07,3.14c-1.83.79-4.71.53-5.76,1.57s-1.83,3.67-5,8.11a45,45,0,0,1-4.34,6l-.37.06s-19.62,3.93-21.71,3.93-3.4,0-3.67,1c-2.09,6.28,1.84,25.12,3.93,32.18-9.29,4.45-20.15,31.66-23,40.29S880.17,932,880.17,933s-3.67,2.36-3.93,2.36-4.45.78-5,1.83.26,4.71.26,4.71a73.73,73.73,0,0,0-2.35,7.59c-1.31,5-.79,18.31-.26,22.76s4.71,25.64,9.94,33.23c.78,11,2.61,18.31,4.18,22s5.76,5,7.07,5.5,9.42,1.31,9.42,1.31,0,.52,2.61,1.3,71.43,0,71.43,0,68.81.79,71.42,0,2.62-1.3,2.62-1.3,8.11-.79,9.42-1.31,5.49-1.83,7.06-5.5,3.41-11,4.19-22c5.23-7.59,9.42-28.78,9.94-33.23S1079.27,954.5,1078,949.53ZM965.46,816.36l1.83-1.05,2.88.78.52.27Zm11,0,.52-.27,2.88-.78,1.83,1.05Zm-2.88-33.23c19.1-.79,25.64,5.49,25.64,5.49a4.65,4.65,0,0,1-1.05.79c-.14,1.27.56,6.63,1.51,12.41l-7.53,15.06-7.07-.1-2.61-3-3.92.52-3.4,2.1v.28l-1.57,0-1.57,0v-.28l-3.4-2.1-3.93-.52-2.6,3-7.08.1-7.52-15.06c.95-5.78,1.65-11.14,1.51-12.41a4.65,4.65,0,0,1-1.05-.79S954.47,782.34,973.57,783.13Z",
    transform: "translate(-831.99 -655)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacBonneReponse);
export default __webpack_public_path__ + "static/media/sac_bonne_reponse.03cf08924ac5d9355da301ae64abdbcf.svg";
export { ForwardRef as ReactComponent };